class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
    // 验证并更新选项
    this.updateSelectOptions();
  }

  updateSelectOptions() {
    // 更新Select2
    if (this.options[1]) {
      let select2 = this.querySelectorAll("select")[1];
      // 获取variants
      let select2_variants = this._getVariantsByOption(
        "option1",
        this.options[0]
      );
      // 获取选项1对应的选项2值
      let select2_values = this._getSelectValuesByVariants(
        "option2",
        select2_variants
      );
      // 判断选项2选中的值是否存在，不存在则默认选择第一个
      if (!select2_values.includes(this.options[1])) {
        this.options[1] = select2_values[0];
      }
      this._updateSelect($(select2), select2_values, this.options[1]);

      // 更新Select3
      if (this.options[2]) {
        let select3 = this.querySelectorAll("select")[2];
        let select3_variants = this._getVariantsByOption(
          "option2",
          this.options[1],
          select2_variants
        );
        let select3_values = this._getSelectValuesByVariants(
          "option3",
          select3_variants
        );
        if (!select3_values.includes(this.options[2])) {
          this.options[2] = select3_values[0];
        }
        this._updateSelect($(select3), select3_values, this.options[2]);
      }
    }
  }

  _getVariantsByOption(key, value, variants = this.getVariantData()) {
    return variants.filter((variant) => variant[key] === value);
  }

  _getSelectValuesByVariants(key, variants) {
    const values = [];
    variants.forEach((variant) => {
      if (!values.includes(variant[key])) {
        values.push(variant[key]);
      }
    });
    return values;
  }

  _updateSelect(select, values, selected_value) {
    let optionsHtml = "";
    values.forEach((value) => {
      optionsHtml += /*html*/ `<option value="${value}" >${value}</option>`;
    });
    select.html(optionsHtml);
    select.find(`option[value='${selected_value}']`).prop("selected", true);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    // if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    // const newMedia = document.querySelector(
    //   `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    // );
    // if (!newMedia) return;
    // const parent = newMedia.parentElement;
    // parent.prepend(newMedia);
    // window.setTimeout(() => { parent.scroll(0, 0) });

    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const swiper = document.getElementById(
      "main-product-gallery-swiper"
    ).swiper;
    const index = this.currentVariant.featured_media.position - 1;
    swiper.slideTo(index);
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    console.log(this.currentVariant.sku, this.currentVariant);
    // 更新SKU
    document.querySelector(`#sku-${this.dataset.section} span`).textContent =
      this.currentVariant.sku;

    // 更新价格
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);
